import React from "react";

// Renders a beat's real waveform (peaks 0..1) as a compact bar strip.
// Returns null when no peaks so callers can fall back gracefully.
export const MiniWaveform = ({ peaks, bars = 40, active = false, className = "" }) => {
  if (!peaks || !peaks.length) return null;
  const step = Math.max(1, Math.floor(peaks.length / bars));
  const shown = [];
  for (let i = 0; i < peaks.length && shown.length < bars; i += step) shown.push(peaks[i]);
  return (
    <div className={`flex items-center gap-[1px] ${className}`} aria-hidden="true" data-testid="mini-waveform">
      {shown.map((p, i) => (
        <span
          key={i}
          className="flex-1 rounded-full"
          style={{ height: `${Math.max(12, p * 100)}%`, backgroundColor: active ? "#e2ff31" : "rgba(226,255,49,0.45)" }}
        />
      ))}
    </div>
  );
};
